/**
 * Tier-1 monitored countries with baseline risk scores.
 * baselineRisk는 월 1회 정기 리뷰로 갱신 — 갱신 시 BASELINE_UPDATED도 함께 변경할 것.
 */
export const BASELINE_UPDATED = '2026-11-01';


export const TIER1_COUNTRIES: Record<string, {
  name: string;
  nameKo: string;
  baselineRisk: number;
  eventMultiplier: number;
  region: string;
}> = {
  US: { name: 'United States', nameKo: '미국', baselineRisk: 12, eventMultiplier: 0.6, region: 'americas' },
  RU: { name: 'Russia', nameKo: '러시아', baselineRisk: 55, eventMultiplier: 1.3, region: 'europe' },
  CN: { name: 'China', nameKo: '중국', baselineRisk: 35, eventMultiplier: 0.8, region: 'asia' },
  UA: { name: 'Ukraine', nameKo: '우크라이나', baselineRisk: 75, eventMultiplier: 1.5, region: 'europe' },
  IR: { name: 'Iran', nameKo: '이란', baselineRisk: 65, eventMultiplier: 1.4, region: 'mena' },
  IL: { name: 'Israel', nameKo: '이스라엘', baselineRisk: 62, eventMultiplier: 1.4, region: 'mena' },
  TW: { name: 'Taiwan', nameKo: '대만', baselineRisk: 45, eventMultiplier: 1.2, region: 'asia' },
  KP: { name: 'North Korea', nameKo: '북한', baselineRisk: 74, eventMultiplier: 1.5, region: 'asia' },
  KR: { name: 'South Korea', nameKo: '한국', baselineRisk: 26, eventMultiplier: 0.9, region: 'asia' },
  JP: { name: 'Japan', nameKo: '일본', baselineRisk: 13, eventMultiplier: 0.5, region: 'asia' },
  SA: { name: 'Saudi Arabia', nameKo: '사우디아라비아', baselineRisk: 72, eventMultiplier: 1.0, region: 'mena' },
  TR: { name: 'Turkey', nameKo: '튀르키예', baselineRisk: 35, eventMultiplier: 1.1, region: 'mena' },
  DE: { name: 'Germany', nameKo: '독일', baselineRisk: 8, eventMultiplier: 0.5, region: 'europe' },
  FR: { name: 'France', nameKo: '프랑스', baselineRisk: 10, eventMultiplier: 0.6, region: 'europe' },
  GB: { name: 'United Kingdom', nameKo: '영국', baselineRisk: 8, eventMultiplier: 0.5, region: 'europe' },
  IN: { name: 'India', nameKo: '인도', baselineRisk: 50, eventMultiplier: 1.0, region: 'asia' },
  PK: { name: 'Pakistan', nameKo: '파키스탄', baselineRisk: 68, eventMultiplier: 1.3, region: 'asia' },
  SY: { name: 'Syria', nameKo: '시리아', baselineRisk: 32, eventMultiplier: 1.5, region: 'mena' },
  YE: { name: 'Yemen', nameKo: '예멘', baselineRisk: 82, eventMultiplier: 1.5, region: 'mena' },
  MM: { name: 'Myanmar', nameKo: '미얀마', baselineRisk: 65, eventMultiplier: 1.4, region: 'asia' },
  VE: { name: 'Venezuela', nameKo: '베네수엘라', baselineRisk: 58, eventMultiplier: 1.2, region: 'americas' },
  BR: { name: 'Brazil', nameKo: '브라질', baselineRisk: 15, eventMultiplier: 0.7, region: 'americas' },
  PH: { name: 'Philippines', nameKo: '필리핀', baselineRisk: 55, eventMultiplier: 1.0, region: 'asia' },
};

export const DEFAULT_BASELINE_RISK = 15;
export const DEFAULT_EVENT_MULTIPLIER = 1.0;

/** Conflict zone floor scores */
export const CONFLICT_ZONE_FLOORS: Record<string, number> = {
  UA: 55,
  IR: 50,
  IL: 58,
  SA: 65,
  SY: 50,
  YE: 65,
  MM: 45,
  SD: 45,
  PK: 55,
};

/** Asia-focus countries for deep analysis */
export const ASIA_FOCUS_COUNTRIES = ['CN', 'TW', 'KR', 'KP', 'JP', 'IN', 'PK', 'PH', 'MM', 'VN', 'TH', 'ID', 'MY', 'SG'];

